import { useTranslation } from "react-i18next";
import { Eye } from "lucide-react";

interface TemplatePreviewPanelProps {
  language: "cs" | "sk";
  previewHtml: string;
}

export default function TemplatePreviewPanel({ language, previewHtml }: TemplatePreviewPanelProps) {
  const { t } = useTranslation();
  return (
    <div className="card">
      <div className="mb-4 flex items-center justify-between">
        <h3 className="font-semibold text-gray-900 dark:text-white">
          <Eye className="mr-2 inline h-5 w-5" />
          {t("opsAdmin.templates.preview")} {language === "sk" ? "(SK)" : "(EN)"}
        </h3>
      </div>

      {/* Preview iframe */}
      <div className="rounded-lg border border-gray-200 bg-white dark:border-gray-700">
        <iframe
          srcDoc={`
            <!DOCTYPE html>
            <html>
              <head>
                <meta charset="UTF-8">
                <style>
                  body { font-family: system-ui, sans-serif; padding: 20px; margin: 0; }
                  * { box-sizing: border-box; }
                </style>
              </head>
              <body>${previewHtml || `<p style="color: #999;">${t("opsAdmin.templates.previewEmpty")}</p>`}</body>
            </html>
          `}
          className="h-[500px] w-full rounded-lg"
          title={t("opsAdmin.templates.previewIframeTitle")}
        />
      </div>
    </div>
  );
}
